import script from "./SignalAddBookmark.vue?vue&type=script&setup=true&lang=js"
export * from "./SignalAddBookmark.vue?vue&type=script&setup=true&lang=js"

import "./SignalAddBookmark.vue?vue&type=style&index=0&id=b103ba50&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b103ba50"]])

export default __exports__